import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.ProtocolAreaController;
const getController = self.customSetting.getProtocolArea;
const postController = self.customSetting.postProtocolArea;

export default {
  // 2-16
  getOrgForChoice: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryOrganization`)
        .then((res) => {
          context.commit("GET_ORGCHOICE_LIST", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  addOrgApplier: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/ApplyOrg`, data)
        .then((res) => {
          context.commit("GET_ORGAPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  delOrgApplier: (context, id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/DelOrgList?apply_Id=${id}`)
        .then((res) => {
          context.commit("GET_ORGAPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  getOrgApplier: (context) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryOrgList`)
        .then((res) => {
          context.commit("GET_ORGAPPLIER_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  // 2-17
  getOrgForCensor: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/VertifyVendorList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  approveOrg: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/VertifyApprove`, data)
        .then((res) => {
          context.commit("GET_ORGCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },
  rejectOrg: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/VendorReturn`, data)
        .then((res) => {
          context.commit("GET_ORGCENSOR_DATA", res.data);
          resolve(res);
        })
        .catch((err) => reject(err));
    });
  },

  // 2-18
  qryFacAttendList: () => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QryFacAttendList`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  protocalAreaQryEmp: (context, word) => {
    return new Promise((resolve, reject) => {
      // ProtocolArea
      axios
        .get(`${baseApi}/${getController}/QryEmp?word=${word}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insProtocalOrg: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsProtocalOrg`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delProtocalOrg: (context, po_id) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DelProtocalOrg`, po_id, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  editProtocalOrg: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/EditProtocalOrg`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  queryMember: (context, params) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${baseApi}/${getController}/QueryMember?${params}`)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  insMember: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/InsMember`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  editMember: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/EditMember`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  delMember: (context, data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`${baseApi}/${postController}/DelMember`, data)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  exportProtocal: (context, obj) => {
    return new Promise((resolve, reject) => {
      axios({
        url: `${baseApi}/${postController}/ExportProtocal`,
        method: "POST",
        responseType: "blob",
        data: obj,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
};
